"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Description = exports.Label = exports.Checkbox = void 0;

var _polished = require("polished");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Media = require("../Media");

var Checkbox = (0, _styledComponents["default"])(_Media.Media).withConfig({
  displayName: "Checkbox",
  componentId: "sc-11aysde-0"
})(["--mediaObjectSpacing:12px;display:flex;align-items:flex-start;position:relative;cursor:pointer;& + &{margin-top:1rem;}input{position:absolute;top:0;left:0;opacity:0;}"]);
exports.Checkbox = Checkbox;

var Label = _styledComponents["default"].div.withConfig({
  displayName: "Checkbox__Label",
  componentId: "sc-11aysde-1"
})(["font-size:", ";line-height:1.25em;font-weight:", ";display:flex;align-items:center;min-height:var(--checkboxStateSize);color:", ";"], function (_ref) {
  var hasDescription = _ref.hasDescription;
  return hasDescription ? '18px' : '16px';
}, function (_ref2) {
  var hasDescription = _ref2.hasDescription;
  return hasDescription ? '500' : 'normal';
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.mode === 'light' ? (0, _polished.transparentize)('0.3', theme.colors.blank) : 'var(--colors-bayoux)';
});

exports.Label = Label;

var Description = _styledComponents["default"].div.withConfig({
  displayName: "Checkbox__Description",
  componentId: "sc-11aysde-2"
})(["font-size:14px;line-height:1.4em;color:#778ca3;margin-top:4px;"]);

exports.Description = Description;